module.exports = __webpack_public_path__ + "static/media/justify-lg-2.15c52c81.jpg";